import React, { useState, useEffect } from 'react';
import { SupportTicket, getTickets } from './support/api';
import { ChatInterface } from './support/components/ChatInterface';
import './support/support.scss';

export const AccountSupport = () => {
    const [tickets, setTickets] = useState<SupportTicket[]>([]);
    const [activeTicket, setActiveTicket] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadTickets();
    }, []);

    const loadTickets = async () => {
        try {
            const data = await getTickets();
            setTickets(data);
            if (data.length > 0 && !activeTicket) {
                setActiveTicket(data[0].id);
            }
        } catch (err) {
            setError('Failed to load tickets');
        } finally {
            setIsLoading(false);
        }
    };

    const handleNewRequest = () => {
        setActiveTicket(null);
    };

    if (isLoading) {
        return <div className="loading">Loading tickets...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    return (
        <div className="account-section">
            <div className="account-section__header">
                <h1 className="account-section__title">Support</h1>
            </div>
            
            <div className="account-section__content">
                <div className="support-layout">
                    <div className="tickets-list">
                        <button 
                            className="btn btn_cta btn_sm"
                            onClick={handleNewRequest}
                        >
                            + New Request
                        </button>
                        {tickets.map(ticket => (
                            <div 
                                key={ticket.id}
                                className={`ticket-item ${activeTicket === ticket.id ? 'active' : ''}`}
                                onClick={() => setActiveTicket(ticket.id)}
                            >
                                <div className="notification"></div>
                                Ticket #{ticket.id}
                            </div>
                        ))}
                    </div>
                    
                    <div className="chat-container">
                        <ChatInterface 
                            ticket={activeTicket ? tickets.find(t => t.id === activeTicket)! : null}
                            onTicketCreated={(newTicket) => {
                                setTickets(prev => [newTicket, ...prev]);
                                setActiveTicket(newTicket.id);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountSupport; 